module.exports = __webpack_public_path__ + "static/img/PK41.447acb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/PK41.jpg
// module id = i/TA
// module chunks = 0